import { Resources } from '@shared/localizations/Resources';
import { ColumnAlignment, ColumnColoringMode, ColumnTotalVisibility } from '../TableColumn.interface';
export var PositionTableColumnId;
(function (PositionTableColumnId) {
    PositionTableColumnId["Swaps"] = "swaps";
    PositionTableColumnId["ExpositionUsd"] = "exposition-usd";
    PositionTableColumnId["Symbol"] = "symbol";
    PositionTableColumnId["NetPl"] = "net-pl";
    PositionTableColumnId["Commissions"] = "commissions";
    PositionTableColumnId["Quantity"] = "quantity";
    PositionTableColumnId["OperationType"] = "operation-type";
    PositionTableColumnId["OpenPrice"] = "open-price";
    PositionTableColumnId["CurrentPrice"] = "current-price";
    PositionTableColumnId["ExpDate"] = "exp-date";
    PositionTableColumnId["GrossPl"] = "gross-pl";
    PositionTableColumnId["StrikePrice"] = "strike-price";
    PositionTableColumnId["PositionId"] = "position-id";
    PositionTableColumnId["NetPlPercent"] = "net-pl-percent";
    PositionTableColumnId["PlOffset"] = "pl-offset";
    PositionTableColumnId["OpenTime"] = "open-time";
    PositionTableColumnId["Account"] = "account";
    PositionTableColumnId["Sl"] = "sl";
    PositionTableColumnId["Tp"] = "tp";
    PositionTableColumnId["Comment"] = "comment";
    PositionTableColumnId["SymbolType"] = "symbol-type";
    PositionTableColumnId["Login"] = "login";
    PositionTableColumnId["SymbolDescription"] = "symbol-description";
    PositionTableColumnId["PositionValue"] = "position-value";
    PositionTableColumnId["SlValue"] = "sl-value";
    PositionTableColumnId["TradingExchange"] = "trading-exchange";
    PositionTableColumnId["Sll"] = "sll";
    PositionTableColumnId["Leverage"] = "leverage";
    PositionTableColumnId["AccruedInterest"] = "accrued-interest";
    PositionTableColumnId["StrategyId"] = "strategy-id";
    PositionTableColumnId["ProductType"] = "product-type";
    PositionTableColumnId["AvailableForSell"] = "available-for-sell";
    PositionTableColumnId["StartOfDayQty"] = "start-of-day-qty";
    PositionTableColumnId["AssetName"] = "asset-name";
    PositionTableColumnId["Close"] = "close";
    PositionTableColumnId["CloseViaOE"] = "close-via-oe";
})(PositionTableColumnId || (PositionTableColumnId = {}));
function getColumnSortingInfo(id) {
    switch (id /*NOSONAR S1479 - switch case is exhaustive*/) {
        case PositionTableColumnId.Account:
            return { groupIndex: 0, index: 0 };
        case PositionTableColumnId.Login:
            return { groupIndex: 0, index: 1 };
        case PositionTableColumnId.Symbol:
            return { groupIndex: 1, index: 0 };
        case PositionTableColumnId.SymbolDescription:
            return { groupIndex: 1, index: 1 };
        case PositionTableColumnId.SymbolType:
            return { groupIndex: 1, index: 2 };
        case PositionTableColumnId.AssetName:
            return { groupIndex: 2, index: 0 };
        case PositionTableColumnId.PositionId:
            return { groupIndex: 2, index: 1 };
        case PositionTableColumnId.OperationType:
            return { groupIndex: 2, index: 2 };
        case PositionTableColumnId.OpenPrice:
            return { groupIndex: 2, index: 3 };
        case PositionTableColumnId.CurrentPrice:
            return { groupIndex: 2, index: 4 };
        case PositionTableColumnId.Quantity:
            return { groupIndex: 2, index: 5 };
        case PositionTableColumnId.StartOfDayQty:
            return { groupIndex: 2, index: 6 };
        case PositionTableColumnId.OpenTime:
            return { groupIndex: 2, index: 7 };
        case PositionTableColumnId.GrossPl:
            return { groupIndex: 2, index: 8 };
        case PositionTableColumnId.PlOffset:
            return { groupIndex: 2, index: 9 };
        case PositionTableColumnId.NetPl:
            return { groupIndex: 2, index: 10 };
        case PositionTableColumnId.NetPlPercent:
            return { groupIndex: 2, index: 11 };
        case PositionTableColumnId.ExpositionUsd:
            return { groupIndex: 2, index: 12 };
        case PositionTableColumnId.PositionValue:
            return { groupIndex: 2, index: 13 };
        case PositionTableColumnId.Commissions:
            return { groupIndex: 2, index: 14 };
        case PositionTableColumnId.Swaps:
            return { groupIndex: 2, index: 15 };
        case PositionTableColumnId.ExpDate:
            return { groupIndex: 2, index: 16 };
        case PositionTableColumnId.StrikePrice:
            return { groupIndex: 2, index: 17 };
        case PositionTableColumnId.Sl:
            return { groupIndex: 2, index: 18 };
        case PositionTableColumnId.Tp:
            return { groupIndex: 2, index: 19 };
        case PositionTableColumnId.SlValue:
            return { groupIndex: 2, index: 20 };
        case PositionTableColumnId.Sll:
            return { groupIndex: 2, index: 21 };
        case PositionTableColumnId.TradingExchange:
            return { groupIndex: 2, index: 22 };
        case PositionTableColumnId.Leverage:
            return { groupIndex: 2, index: 23 };
        case PositionTableColumnId.StrategyId:
            return { groupIndex: 2, index: 24 };
        case PositionTableColumnId.Close:
            return { groupIndex: 2, index: 25 };
        case PositionTableColumnId.CloseViaOE:
            return { groupIndex: 2, index: 26 };
        default:
            return undefined;
    }
}
export function createPositionTableColumns(tableColumnParams) {
    const isAllowedColumn = (column) => {
        if (Resources.isHidden(column.localizationKey)) {
            return false;
        }
        switch (column.id) {
            case PositionTableColumnId.Sl:
            case PositionTableColumnId.Tp:
            case PositionTableColumnId.Sll:
                return tableColumnParams.isProtectiveOrders === false;
            case PositionTableColumnId.SlValue:
                return tableColumnParams.isAllowSlTp === true;
            case PositionTableColumnId.ProductType:
                return tableColumnParams.isShowProductType === true;
        }
        return true;
    };
    const columns = [
        {
            id: PositionTableColumnId.Symbol,
            localizationKey: 'panel.positions.Symbol',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Symbol)
        },
        {
            id: PositionTableColumnId.Account,
            localizationKey: 'panel.positions.Account',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Account)
        },
        {
            id: PositionTableColumnId.Quantity,
            localizationKey: 'panel.positions.Qunatity',
            visible: true,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Quantity)
        },
        {
            id: PositionTableColumnId.OpenPrice,
            localizationKey: 'panel.positions.Basis',
            visible: true,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.OpenPrice)
        },
        {
            id: PositionTableColumnId.ExpDate,
            localizationKey: 'panel.positions.ExpDate',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.ExpDate)
        },
        {
            id: PositionTableColumnId.StrikePrice,
            localizationKey: 'panel.positions.strike',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.StrikePrice)
        },
        {
            id: PositionTableColumnId.PositionId,
            localizationKey: 'panel.positions.pos_number',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.PositionId)
        },
        {
            id: PositionTableColumnId.OperationType,
            localizationKey: 'panel.positions.Operation',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.OperationType)
        },
        {
            id: PositionTableColumnId.OpenTime,
            localizationKey: 'panel.positions.date_time',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.OpenTime)
        },
        {
            id: PositionTableColumnId.CurrentPrice,
            localizationKey: 'panel.positions.cur_price',
            visible: true,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.Previous,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.CurrentPrice)
        },
        {
            id: PositionTableColumnId.Sl,
            localizationKey: 'panel.positions.SL',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Sl)
        },
        {
            id: PositionTableColumnId.Tp,
            localizationKey: 'panel.positions.TP',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Tp)
        },
        {
            id: PositionTableColumnId.GrossPl,
            localizationKey: 'panel.positions.profit_usd',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.Signed,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.GrossPl)
        },
        {
            id: PositionTableColumnId.Swaps,
            localizationKey: 'panel.positions.swaps',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Swaps)
        },
        {
            id: PositionTableColumnId.ExpositionUsd,
            localizationKey: 'panel.positions.exposition_usd',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.ExpositionUsd)
        },
        {
            id: PositionTableColumnId.Commissions,
            localizationKey: 'panel.positions.commissions',
            visible: true,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Commissions)
        },
        {
            id: PositionTableColumnId.Comment,
            localizationKey: 'panel.positions.comments',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Comment)
        },
        {
            id: PositionTableColumnId.SymbolType,
            localizationKey: 'panel.positions.type',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.SymbolType)
        },
        {
            id: PositionTableColumnId.Login,
            localizationKey: 'panel.positions.Login',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Login)
        },
        {
            id: PositionTableColumnId.SymbolDescription,
            localizationKey: 'panel.positions.SymbolDescription',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.SymbolDescription)
        },
        {
            id: PositionTableColumnId.PlOffset,
            localizationKey: 'panel.positions.PL_ticks',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.Signed,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.PlOffset)
        },
        {
            id: PositionTableColumnId.NetPl,
            localizationKey: 'panel.positions.Net_PL',
            visible: true,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.Signed,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.NetPl)
        },
        {
            id: PositionTableColumnId.PositionValue,
            localizationKey: 'panel.positions.PositionValue',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.PositionValue)
        },
        {
            id: PositionTableColumnId.SlValue,
            localizationKey: 'panel.positions.SL_Value',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.SlValue)
        },
        {
            id: PositionTableColumnId.ProductType,
            localizationKey: 'panel.positions.ProductType',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.ProductType)
        },
        {
            id: PositionTableColumnId.AvailableForSell,
            localizationKey: 'panel.positions.AvailableForSell',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.AvailableForSell)
        },
        {
            id: PositionTableColumnId.Close,
            localizationKey: 'panel.positions.Close',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Close)
        },
        {
            id: PositionTableColumnId.TradingExchange,
            localizationKey: 'panel.positions.ExchangeTrading',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.TradingExchange)
        },
        {
            id: PositionTableColumnId.Sll,
            localizationKey: 'panel.positions.SLL',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Sll)
        },
        {
            id: PositionTableColumnId.StartOfDayQty,
            localizationKey: 'panel.positions.StartOfDayQty',
            visible: true,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.StartOfDayQty)
        },
        {
            id: PositionTableColumnId.AssetName,
            localizationKey: 'panel.positions.AssetName',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.AssetName)
        },
        {
            id: PositionTableColumnId.Leverage,
            localizationKey: 'panel.positions.Leverage',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.Leverage)
        },
        {
            id: PositionTableColumnId.AccruedInterest,
            localizationKey: 'panel.positions.AccruedInterest',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.AccruedInterest)
        },
        {
            id: PositionTableColumnId.NetPlPercent,
            localizationKey: 'panel.positions.Net_PL_Percent',
            visible: false,
            alignment: ColumnAlignment.Right,
            coloringMode: ColumnColoringMode.Signed,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.NetPlPercent)
        },
        {
            id: PositionTableColumnId.CloseViaOE,
            localizationKey: 'panel.positions.CloseViaOE',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.CloseViaOE)
        },
        {
            id: PositionTableColumnId.StrategyId,
            localizationKey: 'panel.positions.StrategyId',
            visible: false,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(PositionTableColumnId.StrategyId)
        }
    ];
    const columnIds = Object.values(PositionTableColumnId);
    columns.sort((a, b) => columnIds.indexOf(a.id) - columnIds.indexOf(b.id));
    return columns.filter(isAllowedColumn);
}
export function getColumnsIdByKeyMap() {
    return new Map([
        ['panel.positions.Symbol', PositionTableColumnId.Symbol],
        ['panel.positions.Account', PositionTableColumnId.Account],
        ['panel.positions.Quantity', PositionTableColumnId.Quantity],
        ['panel.positions.Basis', PositionTableColumnId.OpenPrice],
        ['panel.positions.ExpDate', PositionTableColumnId.ExpDate],
        ['panel.positions.strike', PositionTableColumnId.StrikePrice],
        ['panel.positions.pos_number', PositionTableColumnId.PositionId],
        ['panel.positions.Operation', PositionTableColumnId.OperationType],
        ['panel.positions.date_time', PositionTableColumnId.OpenTime],
        ['panel.positions.cur_price', PositionTableColumnId.CurrentPrice],
        ['panel.positions.SL', PositionTableColumnId.Sl],
        ['panel.positions.TP', PositionTableColumnId.Tp],
        ['panel.positions.profit_usd', PositionTableColumnId.GrossPl],
        ['panel.positions.swaps', PositionTableColumnId.Swaps],
        ['panel.positions.exposition_usd', PositionTableColumnId.ExpositionUsd],
        ['panel.positions.commissions', PositionTableColumnId.Commissions],
        ['panel.positions.comments', PositionTableColumnId.Comment],
        ['panel.positions.type', PositionTableColumnId.SymbolType],
        ['panel.positions.Login', PositionTableColumnId.Login],
        ['panel.positions.SymbolDescription', PositionTableColumnId.SymbolDescription],
        ['panel.positions.PL_ticks', PositionTableColumnId.PlOffset],
        ['panel.positions.Net_PL', PositionTableColumnId.NetPl],
        ['panel.positions.PositionValue', PositionTableColumnId.PositionValue],
        ['panel.positions.SL_Value', PositionTableColumnId.SlValue],
        ['panel.positions.ProductType', PositionTableColumnId.ProductType],
        ['panel.positions.AvailableForSell', PositionTableColumnId.AvailableForSell],
        ['panel.positions.Close', PositionTableColumnId.Close],
        ['panel.positions.ExchangeTrading', PositionTableColumnId.TradingExchange],
        ['panel.positions.SLL', PositionTableColumnId.Sll],
        ['panel.positions.StartOfDayQty', PositionTableColumnId.StartOfDayQty],
        ['panel.positions.AssetName', PositionTableColumnId.AssetName],
        ['panel.positions.Leverage', PositionTableColumnId.Leverage],
        ['panel.positions.AccruedInterest', PositionTableColumnId.AccruedInterest],
        ['panel.positions.Net_PL_Percent', PositionTableColumnId.NetPlPercent],
        ['panel.positions.CloseViaOE', PositionTableColumnId.CloseViaOE],
        ['panel.positions.StrategyId', PositionTableColumnId.StrategyId]
    ]);
}
